<template>
  <div class="container page lottery">
    <!-- 固定顶部渐变背景 -->
    <div class="top-gradient-bg">
      <van-nav-bar class="nav-bar" :title="lottery.name">
        <template #left>
          <van-icon name="arrow-left" color="#fff" @click="back()" />
        </template>
      </van-nav-bar>

      <!-- 期数和倒计时区域 -->
      <div class="period-info">
        <div class="period-left">
<div class="label"><span style="color: red;font-size: 16PX;">{{ lottery.next_expect }}</span></div>
<div class="label" style="line-height: 24PX;font-size: 12PX;font-weight: 600">{{ $t("auth.top33") }} </div>
          <div class="countdown">
            <van-count-down :time="time" @finish="check()" />
          </div>
        </div>
        <div class="period-right">
<div class="label"><span style="color: red;font-size: 16PX;">{{ lottery.now_expect }} </span></div>
<div class="label" style="line-height: 24PX;font-size: 12PX;font-weight: 600">{{ $t("auth.top34") }}</div>
          <div class="tags">
            <span class="tag orange">{{ size }}</span>
            <span class="tag blue"> {{double}}</span>
            <van-icon name="clock-o" size="14PX" color="#000" @click="active = true" style="margin-left: 8px;" />
          </div>
        </div>
      </div>
    </div>

    <!-- 可滚动内容区域 -->
    <div class="scrollable-content">
      <!-- 当前打榜歌曲模块（显示所有选中的歌曲） -->
      <div class="current-song-section" v-if="selectedSongs.length > 0">
        <div class="current-song-title">{{lottery.name}}-{{ lottery.now_expect }}-{{$t('auth.top53')}}</div>
        <div class="current-song-item" v-for="song in selectedSongs" :key="song.id" @click="toDetail(song.id)">
          <img 
            v-if="song.img_url" 
            :src="song.img_url" 
            class="current-song-thumb" 
            alt=""
          />
          <div class="current-song-info">
            <div class="current-song-name">{{ song.xuanfei_name }}</div>
            <div class="current-song-artist">{{ song.bust }}</div>
          </div>
          <div class="current-song-duration">
            <van-icon name="play-circle-o" size="14PX" color="#999" />
            <span v-if="song.danwei==1">{{ song.dianzan }}{{$t('auth.top42')}}</span>
            <span v-else>{{ song.dianzan }}{{$t('auth.top41')}}</span>
          </div>
        </div>
      </div>

      <!-- 主体内容区 -->
      <div class="main-content">
        <!-- 四个选项（一排显示） -->
        <div class="sumValueTwoSides">
          <div
            class="rectangle large"
            :class="{ active: choose[v.type] }"
            v-for="(v, key) in lottery_peilv_list"
            :key="key"
            @click="choosePlay(v.type, v.name)"
          >
            <p class="name-text">{{ v.name == 'big' ? rose : v.name == 'small' ? lily : v.name == 'one' ? fireworks : balloon }}</p>
          </div>
        </div>

        <!-- 品牌Logo拼图区 -->
        <div class="brands-area">
          <div class="brand-item" v-for="item in brandLogos" :key="item.ico">
            <img :src="item.ico" class="brand-img" />
          </div>
        </div>
      </div>
    </div>
<!-- 固定底部操作栏 -->
<div class="bottom-bar">
  <!-- 第一行：输入框 + 余额 -->
  <div class="money-row">
    <div class="money-input-box">
      <van-field
        v-model="money"
        type="digit"
        :placeholder="$t('reservation.price_place')"
        class="money-input"
      />
      <span class="unit">{{ $t("reservation.unit") }}</span>
    </div>
    <div class="balance">
      {{ $t("reservation.available_balance") }}: <span class="balance-num">{{ userInfo.money }}</span>
    </div>
  </div>
<div>
<div style="display: flex;align-items: center;height: 32PX;line-height: 32PX;background: #2a2a2a;padding: 0 0PX 0PX 15PX;color: #fff;font-size: 14PX">
{{ $t("reservation.total") }} <span class="count-num" style="padding: 0 5PX;">{{ formData.length }}</span> {{ $t("reservation.note") }}, {{ $t("reservation.money") }} <span class="total-num" style="padding: 0 5PX;">{{ totalMoney }}</span> {{ $t("reservation.unit") }}
</div>
</div>
  <!-- 第二行：清除 + 总额 + 提交 -->
  <div class="bottom-btns">
    <div class="btn clear-btn" @click="allClear()">{{ $t("reservation.clear_order") }}</div>
    
    <div class="btn submit-btn" @click="doSub()">{{ $t("reservation.submit") }}</div>
  </div>
</div>


    <!-- 结算弹窗 -->
    <van-popup v-model="jiesuanpage" round position="center" :style="{ width: '80%' }">
      <div class="confirm-order-modal">
        <div class="head">
          <p class="text">{{ $t("reservation.task_list") }}</p>
          <van-icon name="cross" class="close-btn" @click="jiesuanpage = false" />
        </div>
        <ul class="list">
          <li v-for="(v, key) in formData" :key="key" class="lise-item">
            <div class="main">
              <p class="bet-name">{{ v.name == 'big' ? rose : v.name == 'small' ? lily : v.name == 'one' ? fireworks : balloon }}</p>
              <p class="detail-text">
                1{{ $t("reservation.note") }}X{{ money }}({{ $t("reservation.unit") }})={{ money }}({{ $t("reservation.unit") }})
              </p>
            </div>
            <van-icon @click="clearChooes(v.type)" name="close" color="#999" />
          </li>
        </ul>
        <div class="sub-bar">
          <van-button class="item cancel-btn" type="default" @click="allClear()">{{ $t("reservation.clear_order") }}</van-button>
          <van-button class="item sub-btn" type="default" @click="doSub">{{ $t("reservation.submit") }}</van-button>
        </div>
      </div>
    </van-popup>

    <!-- 历史记录覆盖层 -->
    <div class="history-overlay" v-if="active" @click.self="active = false">
      <div class="history-panel">
        <div class="history-header">
          <span>{{ $t("auth.top35") }}</span>
          <van-icon name="cross" @click="active = false" />
        </div>
        <div class="history-scroll" @touchmove.stop.prevent>
          <van-pull-refresh v-model="isLoading" @refresh="onRefresh">
            <div class="history-wrapper">
              <div class="item">
                <div class="left font-weight">{{ $t("reservation.num") }}</div>
                <div class="right font-weight">{{ $t("auth.top34") }}</div>
              </div>
              <div class="item" v-for="(v, key) in lottery_list" :key="key">
                <div class="left font-weight">{{ v.expect }}</div>
                <div class="right font-weight">
                  <div class="result-box">
                    <span class="res-des middle orange">{{ (v.opencode[0] + v.opencode[1] + v.opencode[2]) >= 11 ? rose : lily }}</span>
                    <span class="res-des middle blue">{{ (v.opencode[0] + v.opencode[1] + v.opencode[2]) % 2 === 0 ? balloon : fireworks }}</span>
                  </div>
                </div>
              </div>
            </div>
          </van-pull-refresh>
        </div>
      </div>
    </div>

    <!-- 右侧切换窗口弹窗 -->
    <van-popup v-model="showModel" position="right" :style="{ width: '70%', height: '100%' }">
      <div class="list">
        <div class="item" v-for="i in gameitemData" :key="i.id" @click="tabList(i.id, i.key)">
          <div class="item-title">切换活动</div>
          <div class="item-content">
            <van-image width="60" height="61" :src="i.ico" />
            <div class="item-name">{{ i.name }}</div>
          </div>
        </div>
      </div>
    </van-popup>
  </div>
</template>

<script>
var time;
var count = 0;
export default {
  data() {
    return {
      jiesuanpage: false,
      showModel: false,
      rose: '',
      lily: '',
      balloon: "",
      fireworks: "",
      choose: {
        big: false,
        small: false,
        one: false,
        two: false
      },
      shopping: false,
      isLoading: false,
      lottery_peilv_list: [],
      lottery_list: [],
      active: false,
      userInfo: {},
      lottery: {},
      time: 0,
      shopchoose: this.$t("reservation.no_choose"),
      gameitem: "",
      formData: [],
      money: "",
      ids: this.$route.query.id,
      keys: this.$route.query.key,
      gameitemData: [],
      selectedSongs: [], // 已选中的歌曲（包含type信息）
      boundSongs: {}, // 每个榜单绑定的歌曲数据
      brandLogos: [
        { ico: '/img/img/1.png' },
        { ico: '/img/img/2.png' },
        { ico: '/img/img/3.png' },
        { ico: '/img/img/4.png' },
        { ico: '/img/img/5.png' },
        { ico: '/img/img/6.png' },
        { ico: '/img/img/7.png' },
        { ico: '/img/img/9.png' },
        { ico: '/img/img/9.png' },
        { ico: '/img/img/10.png' },
        { ico: '/img/img/11.png' },
        { ico: '/img/img/12.png' },
      ]
    };
  },
  computed: {
    convertedShopchoose() {
      const mapping = {
        big: this.rose,
        small: this.lily,
        one: this.fireworks,
        two: this.balloon
      };
      return this.shopchoose.split(',').map(keyword => mapping[keyword] || keyword).join(',');
    },
    totalMoney() {
      if (!this.formData || this.formData.length === 0) return 0;
      if (!this.money || isNaN(this.money) || parseFloat(this.money) <= 0) return 0;
      const amount = parseFloat(this.money) * this.formData.length;
      return amount > 0 ? amount.toFixed(2) : '0.00';
    }
  },
  methods: {
    back() {
      return window.history.back();
    },
    // 从xuanfeilist获取50条数据，为每个榜单分配10条不同的数据
    async getBoundSongs() {
      const allSongs = await this.$http({
        method: "get",
        url: "xuanfeilist",
        data: { page: 1, limit: 50 }
      }).then(res => res.data);
      
      if (!allSongs || allSongs.length < 10) return;
      
      // 打乱数组，确保每个榜单数据不同
      const shuffled = [...allSongs].sort(() => Math.random() - 0.5);
      
      // 为4个榜单各取10条不同的数据
      this.boundSongs = {
        big: shuffled.slice(0, 10),
        small: shuffled.slice(10, 20),
        one: shuffled.slice(20, 30),
        two: shuffled.slice(30, 40)
      };
      
      // 处理多语言
      const lanng = localStorage.getItem("lang") || "zh";
      Object.keys(this.boundSongs).forEach(type => {
        this.boundSongs[type].forEach(song => {
          if (song.flag) {
            const parts = song.flag.split("|");
            lanng == "zh"
              ? (song.flag = parts[0])
              : lanng == "en"
              ? (song.flag = parts[1])
              : lanng == "ja"
              ? (song.flag = parts[2])
              : (song.flag = parts[3]);
          }
        });
      });
    },
    // 点击榜单
    choosePlay(type, name) {
      if (this.choose[type] === true) {
        // 取消选中：精确移除对应榜单的歌曲
        this.choose[type] = false;
        this.removeSong(type);
        // 从formData中移除
        for (var i = 0; i < this.formData.length; i++) {
          if (type === this.formData[i]["type"]) {
            this.formData.splice(i, 1);
            break;
          }
        }
      } else {
        // 选中：添加歌曲
        this.choose[type] = true;
        this.addSong(type);
        
        // 加入formData
        this.formData.push({ name: name, type: type });
      }
    },
    // 从该榜单10条数据中随机选一首添加到selectedSongs
    addSong(type) {
      const songs = this.boundSongs[type];
      if (!songs || songs.length === 0) return;
      
      // 随机选一首
      const randomIndex = Math.floor(Math.random() * songs.length);
      const song = songs[randomIndex];
      
      // 检查是否已存在（避免重复）
      if (!this.selectedSongs.find(s => s.id === song.id)) {
        // 存储歌曲时加上type字段，方便精确移除
        this.selectedSongs.push({
          ...song,
          type: type // 记录该歌曲属于哪个榜单
        });
      }
    },
    // 取消选中时精确移除对应榜单的歌曲
    removeSong(type) {
      if (this.selectedSongs.length > 0) {
        // 找到属于该type的歌曲并移除
        this.selectedSongs = this.selectedSongs.filter(song => song.type !== type);
      }
    },
    toDetail(id) {
      this.$router.push({ path: "/detail", query: { id: id } });
    },
    doSub() {
      if (this.money === "0") {
        this.$toast(this.$t("reservation.money_err"));
        return false;
      }
      if (this.formData.length === 0) {
        this.$toast(this.$t("reservation.choose_num"));
        return false;
      } else if (this.money === "") {
        this.$toast(this.$t("reservation.price_place"));
        return false;
      } else {
        if (this.userInfo.money - this.money * this.formData.length < 0) {
          this.$toast(this.$t("reservation.balance_enough"));
          return false;
        } else {
          this.$http({
            method: "post",
            data: {
              item: this.gameitem,
              money: this.money,
              lid: this.lottery.id,
              mid: this.userInfo.id,
              expect: this.lottery.now_expect
            },
            url: "game_place_order"
          }).then((res) => {
            if (res.code === 200) {
              this.$toast(this.$t("auth.top54"));
              this.allClear();this.selectedSongs = []; 
              this.getUserInfo();
            } else if (res.code === 401) {
              this.$toast(res.msg);
            }
          });
          return true;
        }
      }
    },
    allClear() {
      for (var i = 0; i < this.formData.length; i++) {
        this.choose[this.formData[i]["type"]] = false;
      }
      this.formData.length = 0;
      this.money = "";
      this.shopchoose = this.$t("reservation.no_choose");
      this.gameitem = "";
      this.shopping = false;
      this.jiesuanpage = false;
      this.selectedSongs = []; // 清空选中的歌曲
    },
    showRight() {
      this.showModel = true;
    },
    jiesuan() {
      if (this.formData.length === 0) {
        this.$toast(this.$t("reservation.choose_num"));
        return false;
      } else if (this.money === "") {
        this.$toast(this.$t("reservation.price_place"));
        return false;
      } else {
        this.jiesuanpage = !this.jiesuanpage;
      }
    },
    clearChooes(type) {
      for (var i = 0; i < this.formData.length; i++) {
        if (type === this.formData[i]["type"]) {
          this.formData.splice(i, 1);
          this.choose[type] = false;
          this.removeSong(type);
        }
      }
      if (this.formData.length >= 1) {
        for (var j = 0; j < this.formData.length; j++) {
          if (j === 0) {
            this.shopchoose = this.formData[j]["name"];
            this.gameitem = this.formData[j]["type"];
          } else {
            this.shopchoose += "," + this.formData[j]["name"];
            this.gameitem += "," + this.formData[j]["type"];
          }
        }
      } else {
        this.shopchoose = this.$t("reservation.no_choose");
        this.gameitem = "";
        this.shopping = false;
      }
      if (this.formData.length === 0) {
        this.jiesuanpage = false;
      }
    },
    check() {
      if (!localStorage.getItem("token")) {
        this.$router.push({ path: "/Login" });
      } else {
        time = window.setInterval(() => {
          setTimeout(() => {
            this.getUserInfo();
            this.getLotteryInfo();
            this.getLotteryList();
            count++;
            if (count > 5) {
              clearInterval(time);
              count = 0;
            }
          }, 0);
        }, 300);
      }
    },
    onRefresh() {
      setTimeout(() => {
        this.$toast(this.$t("reservation.refresh"));
        this.getLotteryList();
        this.isLoading = false;
      }, 200);
    },
    getUserInfo() {
      this.$http({
        method: "get",
        url: "user_info"
      }).then((res) => {
        if (res.code === 200) {
          this.userInfo = res.data;
        } else if (res.code === 401) {
          this.$toast(res.msg);
        }
      });
    },
    getLotteryPeilv() {
      this.$http({
        method: "get",
        data: { id: this.ids },
        url: "lottery_get_peilv"
      }).then((res) => {
        if (res.code === 200) {
          this.lottery_peilv_list = res.data;
        } else if (res.code === 401) {
          this.$toast(res.msg);
        }
      });
    },
    getLotteryList() {
      this.$http({
        method: "get",
        data: { key: this.keys },
        url: "lottery_get_one_list"
      }).then((res) => {
        if (res.code === 200) {
          this.lottery_list = res.data;
          this.getLotteryPeilv();
        } else if (res.code === 401) {
          this.$toast(res.msg);
        }
      });
    },
    getGameItem() {
      this.$http({
        method: 'get',
        url: 'lottery_list'
      }).then(res => {
        this.gameitemData = res.data;
      });
    },
    tabList(id, key) {
      this.ids = id;
      this.keys = key;
      this.showModel = false;
      this.getUserInfo();
      this.getGameItem();
      this.getLotteryInfo();
      this.getLotteryList();
    },
    getLotteryInfo() {
      this.$http({
        method: "get",
        data: { key: this.keys },
        url: "lottery_get_info"
      }).then((res) => {
        const lanng = this.$t("auth.lang");
        if (res.code === 200) {
          if (parseFloat(this.userInfo.money) < parseFloat(res.data.condition)) {
            this.$toast(this.$t("reservation.contact_admin"));
            this.$router.push({ path: "/Home" });
            return false;
          }
          this.lottery = res.data;
          this.time = res.data.second * 1000;
          if (lanng == 'en') {
            this.lottery.name = res.data.name_es;
          }
          if (lanng == 'ja') {
            this.lottery.name = res.data.name_ja;
          }
          if (lanng == 'kr') {
            this.lottery.name = res.data.name_kr;
          }
          if (this.time / 1000 === 59) {
            this.$toast(this.$t("reservation.prize_succ") + this.lottery.now_expect);
          }
          this.sum = res.data.opencode[0] + res.data.opencode[1] + res.data.opencode[2];
          if (this.sum >= 11 && this.sum <= 18) {
            lanng == 'zh' ? this.size = '新歌榜' : lanng == 'en' ? this.size = 'Rising' : lanng == 'ja' ? this.size = '新曲' : this.size = '신곡';
          } else if (this.sum >= 3 && this.sum <= 10) {
            lanng == 'zh' ? this.size = '飙升榜' : lanng == 'en' ? this.size = 'Trending' : lanng == 'ja' ? this.size = "急上昇" : this.size = '급상승';
          }
          if (this.sum % 2 === 0) {
            lanng == 'zh' ? this.double = "热歌榜" : lanng == 'en' ? this.double = "Hot" : lanng == 'ja' ? this.double = "ヒット" : this.double = "인기";
          } else {
            lanng == 'zh' ? this.double = "日更榜" : lanng == 'en' ? this.double = "Daily" : lanng == 'ja' ? this.double = "日次" : this.double = "일일";
          }
        } else if (res.code === 401) {
          this.$toast(res.msg);
        }
      });
    }
  },
  created() {
    if (!localStorage.getItem("token")) {
      this.$router.push({ path: "/Login" });
    } else {
      this.getUserInfo();
      this.getGameItem();
      this.getLotteryInfo();
      this.getLotteryList();
      this.getBoundSongs(); // 获取每个榜单的10条数据
    }
    const lang = this.$t("auth.lang");
 if (lang == 'zh') {
   this.rose = '新歌榜';
   this.lily = '飙升榜';
   this.balloon = '热歌榜';
   this.fireworks = '日更榜';
 } else if (lang == 'en') {
   // 缩短英文标签，防止换行
   this.rose = 'Rising';
   this.lily = 'Trending';
   this.balloon = 'Hot';
   this.fireworks = 'Daily';
 } else if (lang == 'ja') {
   this.rose = '新曲';
   this.lily = '急上昇';
   this.balloon = 'ヒット';
   this.fireworks = '日次';
 } else {
   this.rose = '신곡';
   this.lily = '급상승';
   this.balloon = '인기';
   this.fireworks = '일일';
 }
  },
  destroyed() {
    clearInterval(time);
  }
};
</script>

<style lang="less" scoped>
.page {
  min-height: 100VH;
  background: #f7f8fa;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

/* 顶部固定渐变区域 */
.top-gradient-bg {
  background: #8600ff;
  padding-bottom: 0PX;
  flex-shrink: 0;
  z-index: 100;
}

.nav-bar {
  background: transparent;
  :deep(.van-nav-bar__title) {
    color: #fff;
    font-size: 18PX;
    font-weight: 600;
  }
  :deep(.van-icon) {
    color: #fff;
  }
}

/* 期数和倒计时 */
.period-info {
  display: flex;
  background-color: #fff;
  justify-content: space-between;
  padding: 20PX;
}

.period-left .label,
.period-right .label {
  font-size: 14PX;
  color: #000;
  font-weight: 700;
}

.countdown {
	font-size: 14PX;
  margin-top: 8PX;
  font-size: 20PX;
  font-weight: 700;
  color: #000;
}

.period-right {
  text-align: right;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
}

.tags {
  margin-top: 8PX;
  display: flex;
  align-items: center;
}

.tag {
  display: inline-block;
  padding: 2PX 2PX;
  border-radius: 4PX;
  color: red;font-size: 12PX;font-weight: 600;font-family: 'DIN Alternate', 'Roboto Condensed', sans-serif;;
  color: #000;
  margin-left: 4PX;
}



/* 可滚动内容区域 */
.scrollable-content {
  flex: 1;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
  padding-bottom: 20PX;
}

/* 当前打榜歌曲模块（显示所有选中的歌曲） */
.current-song-section {
  margin: 15PX 15PX 0;
  background: #fff;
  border-radius: 12PX;
  padding: 15PX;
  box-shadow: 0 2PX 8PX rgba(0, 0, 0, 0.05);
}

.current-song-title {
  font-size: 14PX;
  font-weight: 600;
  color: #999;
  margin-bottom: 10PX;
}

/* 歌曲项之间添加分隔线 */
.current-song-item {
  display: flex;
  align-items: center;
  cursor: pointer;
  padding: 10PX 0;
  border-bottom: 1PX solid #f5f5f5;
}

.current-song-item:last-child {
  border-bottom: none;
}

.current-song-thumb {
  width: 50PX;
  height: 50PX;
  border-radius: 8PX;
  object-fit: cover;
  flex-shrink: 0;
}

.current-song-info {
  flex: 1;
  margin-left: 12PX;
  overflow: hidden;
}

.current-song-name {
  font-size: 16PX;
  font-weight: 600;
  color: #333;
  margin-bottom: 4PX;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.current-song-artist {
  font-size: 13PX;
  color: #999;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.current-song-duration {
  font-size: 13PX;
  color: #999;
  flex-shrink: 0;
  display: flex;
  align-items: center;
  gap: 4PX;
}

/* 主体内容 */
.main-content {
  padding: 20PX 15PX 15PX;
}

/* 四个选项 - 一排显示 */
.sumValueTwoSides {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 10PX;
  margin-bottom: 10PX;
}

.rectangle.large {
  background: #fff;
  border-radius: 8PX;
  height: 50PX;
  line-height: 50PX;
  text-align: center;
  cursor: pointer;
  box-shadow: 0 2PX 8PX rgba(0, 0, 0, 0.05);
}

.rectangle.large.active {
  background: #dc3b40;
}

.rectangle.large .name-text {
  font-size: 12PX;
  font-weight: 700;
  color: #333;
  margin: 0;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.rectangle.large.active .name-text {
  color: #fff;
}

/* 品牌Logo拼图区 */
.brands-area {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 10PX;
  margin-top: 20PX;
  margin-bottom: 20PX;
  padding: 0;
  background: transparent;
  border-radius: 0;
}

.brand-item {
  width: 100%;
  height: 80PX;
  display: flex;
  justify-content: center;
  align-items: center;
  background: #fff;
  border-radius: 8PX;
  box-shadow: 0 2PX 8PX rgba(0, 0, 0, 0.05);
  overflow: hidden;
}

.brand-img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 8PX;
}

/* 底部固定操作栏 */
.bottom-bar {
  flex-shrink: 0;
  background: #fff; /* 深色背景 */
  padding: 15PX 0 0 0;
  z-index: 99;
}

/* 第一行：输入框 + 余额 */
.money-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 15PX;
  margin-bottom: 12PX;
}

.money-input-box {
  flex: 1;
  display: flex;
  align-items: center;
  border: 1PX solid #555;
  border-radius: 6PX;
  overflow: hidden;
  background: #fff;
  height: 40PX;
}

.money-input {
  flex: 1;
  background: transparent;
  :deep(.van-field__control) {
    font-size: 16PX;
    color: #333;
    text-align: center;
  }
}

.unit {
  background: #f5f5f5;
  color: #333;
  font-size: 14PX;
  padding: 0 12PX;
  line-height: 40PX;
  border-left: 1PX solid #ddd;
}

.balance {
  margin-left: 15PX;
  font-size: 14PX;
  color: #000;
  white-space: nowrap;
}

.balance-num {
  color: #ff5f6d;
  font-weight: 700;
}

/* 第二行：底部按钮 */
.bottom-btns {
  display: flex;
  align-items: center;
  height: 50PX;
  background: #2a2a2a;
  padding: 0 0PX 0PX  15PX;
}

/* 清除按钮：深色背景，灰色边框 */
.clear-btn {
  flex-shrink: 0;
  height: 34PX;
  line-height: 32PX;
  padding: 0 20PX;
  background: transparent;
  color: #ccc;
  border: 1PX solid #666;
  border-radius: 6PX;
  font-size: 14PX;
}

/* 中间总额 */
.count-btn {
  flex: 1;
  text-align: center;
  font-size: 14PX;
  color: #fff;
  white-space: nowrap;
  overflow: hidden;
}

/* 数量红色 */
.count-num {
  color: #ff5f6d;
  font-weight: 700;
}

/* 总额红色加粗 */
.total-num {
  color: #ff5f6d;
  font-weight: 700;
}

/* 提交按钮：红色背景 */
/* 提交按钮：红色背景，靠右 */
.submit-btn {
  flex-shrink: 0;
  height: 50PX;
  line-height: 50PX;
  padding: 0 30PX;
  background: #e60012;
  color: #fff;
  font-size: 15PX;
  font-weight: 600;
  border-radius: 0;
  margin-left: auto; /* 让它固定在右侧 */
}
/* 结算弹窗 */
.confirm-order-modal {
  padding: 20PX;
  background: #fff;
  border-radius: 12PX;
  width: 100%;
}

.confirm-order-modal .head {
  position: relative;
  text-align: center;
  margin-bottom: 10PX;
}

.confirm-order-modal .head .text {
  font-size: 16PX;
  font-weight: 600;
  color: #333;
}

.confirm-order-modal .head .close-btn {
  position: absolute;
  right: 0;
  top: 0;
  color: #999;
  font-size: 18PX;
  cursor: pointer;
}

.confirm-order-modal .list .lise-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10PX 0;
  border-bottom: 1PX solid #f5f5f5;
}

.confirm-order-modal .list .lise-item .bet-name {
  font-size: 14PX;
  color: #333;
  font-weight: 600;
}

.confirm-order-modal .list .lise-item .detail-text {
  font-size: 12PX;
  color: #999;
}

.confirm-order-modal .sub-bar {
  display: flex;
  gap: 10PX;
  margin-top: 20PX;
}

.confirm-order-modal .sub-bar .item {
  flex: 1;
  height: 40PX;
  line-height: 40PX;
  border-radius: 8PX;
  font-size: 14PX;
  padding: 0;
}

.confirm-order-modal .sub-bar .cancel-btn {
  background: #f7f8fa;
  color: #333;
}

.confirm-order-modal .sub-bar .sub-btn {
  background: linear-gradient(90deg, #ff5f6d, #ff2d55);
  color: #fff;
}

/* 历史记录覆盖层 */
.history-overlay {
  position: fixed;
  top: 160PX;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.6);
  z-index: 200;
  display: flex;
  flex-direction: column;
}

.history-panel {
  background: #f7f8fa;
  flex: 1;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.history-header {
  background: #fff;
  padding: 15PX;
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 16PX;
  font-weight: 600;
  color: #333;
  border-bottom: 1PX solid #f0f0f0;
}

.history-header .van-icon {
  font-size: 20PX;
  cursor: pointer;
}

.history-scroll {
  flex: 1;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
  background: #f7f8fa;
}

.history-wrapper {
  padding: 15PX;
}

.history-wrapper .item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10PX;
  background: #fff;
  margin-bottom: 10PX;
}

.history-wrapper .item .left,
.history-wrapper .item .right {
  font-size: 14PX;
  color: #333;
}

.result-box {
  display: flex;
  gap: 10PX;
}

.res-des.middle {
  // background: #dc3b40;
  color: #fff;
  // padding: 4PX 10PX;
  // border-radius: 4PX;
  font-size: 14PX;
  font-weight: 700;
}

/* 弹窗和列表通用 */
.list {
  padding: 15PX;
}

.list .item {
  background: #f7f8fa;
  border-radius: 8PX;
  padding: 15PX;
  margin-bottom: 15PX;
}

.list .item .item-title {
  font-size: 14PX;
  color: #333;
  margin-bottom: 10PX;
}

.list .item .item-content {
  display: flex;
  align-items: center;
  gap: 10PX;
}

.list .item .item-name {
  font-size: 14PX;
  font-weight: 600;
  color: #333;
}

::v-deep .van-count-down {
  font-size: 16PX;
  line-height: 32PX;
}

::v-deep .van-field__control {
  font-size: 14PX;
  line-height: 32PX;
  color: #333;
}

::v-deep .van-field__control::placeholder {
  font-size: 14PX;
  line-height: 32PX;
  color: #999;
}
::v-deep .van-count-down{
	color: red;font-size: 24PX;font-weight: 700;font-family: 'Courier New', monospace;
}
.orange{
	background: linear-gradient(90deg, #ff7e5f, #ff5f6d);padding: 4PX 6PX;border-radius: 5PX;color: #fff;
}
.blue{
	background:#7c4dff;;padding: 4PX 6PX;border-radius: 5PX;color: #fff;
}
</style>